// TODO: add pagination and sorting to this mixin.
import vuexKeys from "@mixins/includes/_vuexKeys";
import resources from "@mixins/permissions/_resources";
import notifications from "@mixins/includes/_notifications";
import query from '@mixins/helpers/_query';
import breadcrumbs from "@mixins/helpers/_breadcrumbs";
import links from "@mixins/helpers/_links";

import Page from "@pages/templates/page";
import MBlockEmptyPageContent from "@modules/blocks/page/m-block-empty-page-content";

let basePage = {
    metaInfo() {
        return {
            title: this.$t(`${this.meta.title}`)
        }
    },
    mixins: [
        resources, vuexKeys, notifications, breadcrumbs, links, query
    ],
    components: {
        Page, MBlockEmptyPageContent
    },
    props: {
        name: {
            type: String,
            required: false
        }
    }
};

export default basePage;
